// extracted by mini-css-extract-plugin
export default {"masonryGrid":"LikesList_masonryGrid__Jjvv-","masonryGridColumn":"LikesList_masonryGridColumn__6AvGi"};